import React from "react";
import { Redirect, Route } from "react-router";
import { useDispatch } from "react-redux";
import { settingRoute } from "@store/route";

function PrivateRoute({ component: Component, ...restOfProps }) {
  const isAuthenticated = localStorage.getItem("user");
  const route = localStorage.getItem("route");
  const dispatch = useDispatch();

  if (!route) {
    dispatch(settingRoute(window.location.href));
  }

  return (
    <>
    {
     isAuthenticated ? <Route {...restOfProps} /> :  <Redirect exact to="/" />
    }
    </>
  );
}

export default PrivateRoute;